export default name => `Hello, ${name}`
